"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPUT = exports.fetchPOST = exports.fetchGET = exports.fetchDELETE = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _axios = _interopRequireDefault(require("axios"));

var objToQueryString = function objToQueryString(obj) {
  if (!Object.values(obj).length) return null;
  return Object.entries(obj).map( //([key, value]) => `${key}=${encodeURIComponent(JSON.stringify(value))}`
  function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(key, "=").concat(encodeURIComponent(value));
  }).join("&");
};
/**
 *	funcion que realiza un axios GET
 *	
 *	Si <body> es undefined significa que hubo error

 * @returns { Promise<{
 * 	body: {} | undefined , 
 * 	message: string, 
 * 	errorDetail: string
 * }> } */


var fetchGET = function fetchGET() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var paramsQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var paramsHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(response) {
      var URL, keysParamsQuery, respHTTPjson, body, _body$message, _body$errorDetail;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              URL = "".concat(endpoint, "?").concat(objToQueryString(paramsQuery));
              keysParamsQuery = Object.keys(paramsQuery); // agregar cada param query a la URL

              _context.next = 5;
              return _axios.default.get(URL, {
                headers: paramsHeaders
              });

            case 5:
              respHTTPjson = _context.sent;

              if (!(respHTTPjson.status !== 200)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", response({
                message: "No fue posible llevar a cabo la operación",
                errorDetail: respHTTPjson.statusText
              }));

            case 8:
              // obtener body backend
              body = JSON.parse(respHTTPjson.data.body); // verificar si existe error desde el backend

              if (!(respHTTPjson.data.statusCode !== 200)) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", response({
                message: (_body$message = body.message) !== null && _body$message !== void 0 ? _body$message : "",
                errorDetail: (_body$errorDetail = body.errorDetail) !== null && _body$errorDetail !== void 0 ? _body$errorDetail : ""
              }));

            case 11:
              return _context.abrupt("return", response({
                body: body
              }));

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", response({
                message: "Error al obtener los datos",
                errorDetail: _context.t0.message
              }));

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
}; //============================================================

/**
 *	funcion que realiza un axios POST
 *	
 *	Si <body> es undefined significa que hubo error

 * @returns { Promise<{
 * 	body: {} | undefined , 
 * 	message: string, 
 * 	errorDetail: string
 * }> }
 *  
 */
//============================================================


exports.fetchGET = fetchGET;

var fetchPOST = function fetchPOST() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var paramsBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var paramsHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise( /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(response) {
      var respHTTPjson, body, _body$message2, _body$errorDetail2;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _axios.default.post(endpoint, paramsBody, {
                headers: paramsHeaders
              });

            case 3:
              respHTTPjson = _context2.sent;

              if (!(respHTTPjson.status !== 200)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return", response({
                message: "No fue posible llevar a cabo la operación",
                errorDetail: respHTTPjson.statusText
              }));

            case 6:
              // obtener body backend
              body = JSON.parse(respHTTPjson.data.body); // verificar si existe error desde el backend

              if (!(respHTTPjson.data.statusCode !== 200)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", response({
                message: (_body$message2 = body.message) !== null && _body$message2 !== void 0 ? _body$message2 : "",
                errorDetail: (_body$errorDetail2 = body.errorDetail) !== null && _body$errorDetail2 !== void 0 ? _body$errorDetail2 : ""
              }));

            case 9:
              return _context2.abrupt("return", response({
                body: body
              }));

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", response({
                message: "Error al guardar los datos",
                errorDetail: _context2.t0.message
              }));

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 12]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }());
}; //============================================================

/**
 *	funcion que realiza un axios GET
 *	
 *	Si <body> es undefined significa que hubo error

 * @returns { Promise<{
 * 	body: {} | undefined , 
 * 	message: string, 
 * 	errorDetail: string
 * }> }
 *  
 */
//============================================================


exports.fetchPOST = fetchPOST;

var fetchPUT = function fetchPUT() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var paramsBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var paramsHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise( /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(response) {
      var respHTTPjson, body, _body$message3, _body$errorDetail3;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _axios.default.put(endpoint, paramsBody, {
                headers: paramsHeaders
              });

            case 3:
              respHTTPjson = _context3.sent;

              if (!(respHTTPjson.status !== 200)) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return", response({
                message: "No fue posible llevar a cabo la operación",
                errorDetail: respHTTPjson.statusText
              }));

            case 6:
              // obtener body backend
              body = JSON.parse(respHTTPjson.data.body); // verificar si existe error desde el backend

              if (!(respHTTPjson.data.statusCode !== 200)) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return", response({
                message: (_body$message3 = body.message) !== null && _body$message3 !== void 0 ? _body$message3 : "",
                errorDetail: (_body$errorDetail3 = body.errorDetail) !== null && _body$errorDetail3 !== void 0 ? _body$errorDetail3 : ""
              }));

            case 9:
              return _context3.abrupt("return", response({
                body: body
              }));

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", response({
                message: "Error al actualizar los datos",
                errorDetail: _context3.t0.message
              }));

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 12]]);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }());
}; //============================================================

/**
 *	funcion que realiza un axios GET
 *	
 *	Si <body> es undefined significa que hubo error

 * @returns { Promise<{
 * 	body: {} | undefined , 
 * 	message: string, 
 * 	errorDetail: string
 * }> }
 *  
 */
//============================================================


exports.fetchPUT = fetchPUT;

var fetchDELETE = function fetchDELETE() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var paramsBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var paramsHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise( /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(response) {
      var respHTTPjson, body, _body$message4, _body$errorDetail4;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _axios.default.delete(endpoint, {
                data: paramsBody,
                headers: paramsHeaders
              });

            case 3:
              respHTTPjson = _context4.sent;

              if (!(respHTTPjson.status !== 200)) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return", response({
                message: "No fue posible llevar a cabo la operación",
                errorDetail: respHTTPjson.statusText
              }));

            case 6:
              // obtener body backend
              body = JSON.parse(respHTTPjson.data.body); // verificar si existe error desde el backend

              if (!(respHTTPjson.data.statusCode !== 200)) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return", response({
                message: (_body$message4 = body.message) !== null && _body$message4 !== void 0 ? _body$message4 : "",
                errorDetail: (_body$errorDetail4 = body.errorDetail) !== null && _body$errorDetail4 !== void 0 ? _body$errorDetail4 : ""
              }));

            case 9:
              return _context4.abrupt("return", response({
                body: body
              }));

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", response({
                message: "Error al actualizar los datos",
                errorDetail: _context4.t0.message
              }));

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 12]]);
    }));

    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }());
};

exports.fetchDELETE = fetchDELETE;